import PropTypes from 'prop-types';
import PotentialReturns from './potential-returns.js';
import MojitoCore from 'mojito/core';

/**
 * View that displays the estimated returns for a specific stake on a bet.
 *
 * @class PotentialReturns
 * @private
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * PotentialReturns prop types.
 *
 * @property {number} potentialReturn - The calculated potential return for the bet, considering any free bets.
 * @property {string} [currencyCode] - The code of the currency to be used in the bet slip.
 * @property {boolean} [disabled = false] - Indicates whether the view is disabled.
 * @property {boolean} [hasAccaBoost = false] - Specifies if the potential return includes an AccaBoost.
 * @memberof Mojito.Modules.Betslip.BetslipView.PotentialReturns
 */
const propTypes = {
    potentialReturns: PropTypes.number.isRequired,
    currencyCode: PropTypes.string,
    disabled: PropTypes.bool,
    hasAccaBoost: PropTypes.bool,
};

const defaultProps = {
    disabled: false,
    hasAccaBoost: false,
};

export default MojitoCore.Presentation.UIView(
    'PotentialReturns',
    PotentialReturns,
    propTypes,
    defaultProps
);
